
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/erp-enquiry",
      function () {
        return require("private-next-pages/partners/erp-enquiry/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/erp-enquiry"])
      });
    }
  